import type {DataLoadByIdStatus} from 'api/types';
import type {
  LinkedRoleCodeList,
  LinkedRoleCodeListId,
} from 'schemaDefinition/types';
import type {Schemas} from 'api/dto.generated';
import type {LoadByIdAction} from 'services/utils/redux/actions';

export type CodeListId =
  | Required<Schemas.CodelistDto>['id']
  | CombinedCodeListId
  | LocalCodeListId
  | 'manifestation_role_type'
  | 'collection_type'
  | 'work_collection_type'
  | 'product_form_simple_values'
  | 'availability_status'
  | 'task_type'
  | 'media_sub_type'
  | 'WORK_TITLE_TYPE'
  | 'WORK_TYPE'
  | 'PRIZE_TYPE'
  // Mass update
  // TODO: Parameterize schemas with CodeListId and codelist lookup
  | 'bulkUpdateWorkField'
  | 'bulkUpdateAction'
  | 'bulkUpdateStatus'
  | 'bulkUpdateType'
  | 'MONTH'
  // Dummy: to allow editing of links without any role
  | 'DUMMY';

export type CodeListsState = DataLoadByIdStatus<CodeList, CodeListId>;

export enum CodeListActionType {
  LOAD_CODELIST = 'LOAD_CODELIST',
}

export type CodeListsAction_LoadById = {
  type: CodeListActionType.LOAD_CODELIST;
} & LoadByIdAction<CodeList, CodeListId>;

export type CodeListsAction = CodeListsAction_LoadById;

//----- CodeList, Code ----------------------------------------------------------------------------

export type CombinedCodeListId = 'WORK_AND_EXPRESSION_ROLE_TYPE';

export const CombinedCodeListIds: Readonly<CombinedCodeListId[]> = [
  'WORK_AND_EXPRESSION_ROLE_TYPE',
] as const;

export const PartCodeLists: Readonly<Record<CombinedCodeListId, CodeListId[]>> =
  {
    WORK_AND_EXPRESSION_ROLE_TYPE: ['WORK_ROLE_TYPE', 'EXPRESSION_ROLE_TYPE'],
  };

// Generated code lists from context
export type LocalCodeListId =
  | 'expression_manifestation' // Manifestations in expression: { code: isbn, value: isbn / format  / år}
  | 'expression_manifestation_based_on'
  | 'expression_manifestation_digital_version'; // Opposite selection of expression_manifestation_based_on

export type Code = {
  code: Schemas.CodeDto['code'];
  value: Schemas.CodeDto['value'];
  deactivated?: Schemas.CodeDto['deactivated'];
  notes?: string;
  disabled?: boolean;
};

export type CodeList = {
  language: Schemas.CodelistDto['language'];
  id: CodeListId;
  codes: Code[];
};

export type StandardCodeListMap = {[key in CodeListId]?: CodeList};

export type LinkedRoleCodeListMap = {
  [key in LinkedRoleCodeListId]?: LinkedRoleCodeList;
};

export type CodeListMap = StandardCodeListMap & LinkedRoleCodeListMap;
